import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  // {
  //   name: "home",
  //   path: "/home",
  //   component: () => import("../views/pages/home/home.vue"),
  // },
  {
    name: "mainPage",
    path: "/mainPage",
    component: () => import("../views/pages/mainPage/mainPage.vue"),
    children: [
      //首页
      {
        name: "home",
        path: "/home",
        component: () => import("../views/pages/home/home.vue"),
      },
      //详情模块
      {
        name: "detailModule",
        path: "/detailModule",
        component: () => import("../components/detailModule.vue"),
        children:[
            //公司简介
            {
              name: "intro",
              path: "/intro",
              component: () => import("../views/pages/intro/intro.vue"),
            },
            //发展历程
            {
              name: "history",
              path: "/history",
              component: () => import("../views/pages/history/history.vue"),
            },
            //企业文化
            {
              name: "culture",
              path: "/culture",
              component: () => import("../views/pages/culture/culture.vue"),
            },
            //企业荣誉列表
            {
              name: "honor",
              path: "/honor",
              component: () => import("../views/pages/honor/honor.vue"),
            },
            //企业荣誉详情
            {
              name: "honorDetail",
              path: "/honorDetail",
              component: () => import("../views/pages/honor/honorDetail.vue"),
            },
        ]
      },
      //新闻/动态详情页
      {
        name: "dynamicDetail",
        path: "/dynamicDetail",
        component: () => import("../views/pages/dynamicDetail/dynamicDetail.vue"),
      },
      //公司动态
      {
        name: "dynamic",
        path: "/dynamic",
        component: () => import("../views/pages/dynamic/dynamic.vue"),
      },
      //公司产品
      {
        name: "product",
        path: "/product",
        component: () => import("../views/pages/product/product.vue"),
      },
      //公司案例
      {
        name: "example",
        path: "/example",
        component: () => import("../views/pages/example/example.vue"),
      },
      //人才招聘
      {
        name: "job",
        path: "/job",
        component: () => import("../views/pages/job/job.vue"),
      },
      //联系我们
      {
        name: "contact",
        path: "/contact",
        component: () => import("../views/pages/contact/contact.vue"),
      },
      //产品详情页
      {
        name: "productExampleDetail",
        path: "/productExampleDetail",
        component: () => import("../views/pages/productExampleDetail/productExampleDetail.vue"),
      },
    ]
  },
  {//容器页 进入一级路由
    path: '/',
    name: 'mainPage',
    component: () => import('../views/pages/mainPage/mainPage.vue'),
    children:[
      {//主页 进入二级路由
        path: '/',
        name: 'home',
        component: () => import('../views/pages/home/home.vue')
      },
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

//解决重复点击菜单导致导航报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location){
  return originalPush.call(this,location).catch(err => err)
}

router.beforeEach((to,from,next)=>{
  next();
  // if(store.state.menulist === undefined){
  //   //放行
  //   setTimeout(()=>{
  //     next();
  //   },2000)
  // }else{
  //   next();
  // }
})

export default router;
